export function initMap() {
    const popovers = document.querySelectorAll<HTMLElement>('.map-popover');
    const items = document.querySelectorAll<SVGCircleElement>('.map-item');
    const container = document.querySelector<HTMLElement>('.map-container');

    const POINT_SIZE = 16;
    const GAP = 10;

    let isOpen = false;

    function closeAllPopovers() {
        popovers.forEach(p => {
            p.style.opacity = '0';
            p.style.pointerEvents = 'none';
        });

        document.body.classList.remove('no-scroll');
        isOpen = false;
    }

    items.forEach(item => {
        let hoverTimeout: number;

        // 📱 MOBILE (click)
        item.addEventListener('click', (e) => {
            if (window.innerWidth >= 991) return;

            e.stopPropagation();
            openPopover(item);
        });

        // 🖥 DESKTOP (hover)
        item.addEventListener('mouseenter', () => {
            if (window.innerWidth < 991) return;

            const popover = openPopover(item);

            if (!popover) return;

            // если наводимся на поповер — не закрывать
            popover.addEventListener('mouseenter', () => {
                clearTimeout(hoverTimeout);
            });

            popover.addEventListener('mouseleave', () => {
                hoverTimeout = window.setTimeout(() => {
                    closeAllPopovers();
                }, 100);
            });
        });

        item.addEventListener('mouseleave', () => {
            if (window.innerWidth < 991) return;

            hoverTimeout = window.setTimeout(() => {
                closeAllPopovers();
            }, 100);
        });
    });


    // ✅ закрытие по кнопке
    popovers.forEach(popover => {
        const closeBtn = popover.querySelector<HTMLElement>('.map-popover-close');
        if (!closeBtn) return;

        closeBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            closeAllPopovers();
        });
    });

    // ✅ клик вне
    document.addEventListener('click', (e) => {
        if (
            !(e.target as HTMLElement).closest('.map-popover') &&
            !(e.target as HTMLElement).closest('.map-item')
        ) {
            closeAllPopovers();
        }
    });

    // ✅ скролл окна
    window.addEventListener('scroll', () => {
        if (isOpen) closeAllPopovers();
    });

    // ✅ скролл контейнера (если есть горизонтальный)
    if (container) {
        container.addEventListener('scroll', () => {
            if (isOpen) closeAllPopovers();
        });
    }
    function openPopover(item: SVGCircleElement) {
        const id = item.getAttribute('data-attr');
        const popover = document.querySelector<HTMLElement>(`.map-popover[data-id="${id}"]`);
        if (!popover) return;

        closeAllPopovers();
        isOpen = true;

        if (window.innerWidth < 991) {
            document.body.classList.add('no-scroll');
        }

        popover.style.opacity = '0';
        popover.style.display = 'flex';
        popover.style.position = 'fixed';
        popover.style.left = '0px';
        popover.style.top = '0px';

        requestAnimationFrame(() => {
            const rect = item.getBoundingClientRect();

            const popoverWidth = popover.offsetWidth;
            const popoverHeight = popover.offsetHeight;

            const centerX = rect.left + POINT_SIZE / 2;
            const centerY = rect.top + POINT_SIZE / 2;

            let left = centerX - popoverWidth / 2;
            let top = centerY - popoverHeight - GAP - 20;

            const vw = window.innerWidth;
            if (left < 4) left = 4;
            if (left + popoverWidth > vw - 4) {
                left = vw - popoverWidth - 4;
            }

            popover.style.left = `${left}px`;
            popover.style.top = `${top}px`;
            popover.style.opacity = '1';
            popover.style.pointerEvents = 'auto';

            const arrow = popover.querySelector<HTMLElement>('.arrow');
            if (arrow) {
                arrow.style.left = `${centerX - left - arrow.offsetWidth / 2}px`;
                arrow.style.top = `${popoverHeight - arrow.offsetHeight / 2}px`;
            }
        });

        return popover;
    }

}

